import { createSlice } from "@reduxjs/toolkit";
import { updateTermsAndConditionsAPI } from "../../services/updateTermsAndConditions";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateTermsAndConditionsSlice = createSlice({
  name: "updateTermsAndConditions",
  initialState,
  reducers: {
    updateTermsAndConditionsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    updateTermsAndConditionsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "Saved successfully";
    },
    updateTermsAndConditionsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    updateTermsAndConditionsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateTermsAndConditionsHandler = (payload) => async (dispatch) => {
  try {
    dispatch(updateTermsAndConditionsAction.updateTermsAndConditionsInfo());
    const response = await updateTermsAndConditionsAPI(payload);
    dispatch(
      updateTermsAndConditionsAction.updateTermsAndConditionsInfoSuccess(
        response,
      ),
    );
    return response;
  } catch (e) {
    dispatch(
      updateTermsAndConditionsAction.updateTermsAndConditionsInfoFailure(
        e?.response?.data?.message || e?.message || String(e),
      ),
    );
    throw e;
  }
};

export default updateTermsAndConditionsSlice.reducer;
export const updateTermsAndConditionsAction =
  updateTermsAndConditionsSlice.actions;

